// specific to SA
import Component from '../../UM-Base/components/Component';

export default class OidcLogout extends Component {
  load() {
    console.log('OIDCLOGOUT.js');
    sessionStorage.setItem('logoutPageVisited', now);  // returns time in milliseconds);
    sessionStorage.removeItem('oidc.user:https://id-test.southaustralia.com/:tripPlannerM');
    sessionStorage.removeItem('oidc.user:https://id.southaustralia.com/:tripPlannerM');

    // Remove this to deal with other tabs and logouts
    localStorage.removeItem('LOGGED_IN');
    super.load();
  }
}
